import React from 'react'
import styles from '../../styles/home.module.css';
import { IMAGEPATH } from '../../constants/imagePath';
import SectionTitle from '../common/SectionTitle';
import SectionTitleSub from '../common/SectionTitleSub';
import { KR } from '../../constants/localizations';

export default function HomeTechnologiesSection() {
    return (
        <div className={styles.tech}>
            <SectionTitle title={KR.label_home_pro_tech} titleEng={KR.label_home_pro_tech_eng} />
            <SectionTitleSub content={"LiDAR 및 카메라 기반 인공지능 기술을 통해 안전한 이동을 보장하는 지속 가능한 솔루션을 제공합니다."} contentEng={"Providing a sustainable solution ensuring safe navigation through LiDAR and camera-based AI technology."} />
            <div className={styles.cardW}>
                <div className={styles.card}>
                    <div>
                        <img src={IMAGEPATH.b1} srcSet={IMAGEPATH.b1Webp} alt="ar247_tech_image_1" loading="lazy" />
                    </div>
                    <div className={styles.cardContent}>
                        <div>
                            <span>
                                {KR.label_home_slam}
                            </span>
                            {KR.label_home_slam_full}
                        </div>
                        <div>
                            <strong>
                                로봇 위치 추정 및 정밀 지도 기술
                            </strong>
                            3D 포인트 클라우드 기반 지도 기술로 50mm 정밀도의 실시간 위치 추정과 3D 지도 제작이 가능하여, 복잡한 환경에서도 안정적이고 정확하게 작동하며 실내외 운영에 최적화되어 있습니다.
                        </div>
                        <div>
                            <strong>
                                다양한 환경에 최적화된 지도 제작 솔루션
                            </strong>
                            도시, 공장, 실내외 등 다양한 환경에 적용 가능한 지도 제작 솔루션을 제공하며, 빠른 현장 도입과 유지 관리가 가능해 완전 무인 자율주행 로봇 운영의 핵심 역할을 수행합니다.
                        </div>
                    </div>
                </div>
                <div className={styles.card}>
                    <div>
                        <img src={IMAGEPATH.b2} srcSet={IMAGEPATH.b2Webp} alt="ar247_tech_image_2" loading="lazy" />
                    </div>
                    <div className={styles.cardContent}>
                        <div>
                            <span>
                                {KR.label_home_ai}
                            </span>
                            {KR.label_home__ai_full}
                        </div>
                        <div>
                            <strong>
                                AI 장애물 인식 기술
                            </strong>
                            AR247의 AI 모델은 3D 라이다, 카메라, 적외선 카메라 등 다양한 센서를 활용해 사람, 자동차, 킥보드, 자전거 등 장애물을 실시간 인식하며, 낮과 밤, 우천, 강한 햇빛 등 다양한 조건에서도 높은 성능을 유지합니다.
                        </div>
                        <div>
                            <strong>
                                고도화된 데이터 기반 AI 학습
                            </strong>
                            자체 취득한 데이터를 바탕으로 AI를 학습시켜 로봇의 안전 자율주행을 지원하며, 속도, 방향, 위치를 분석해 고객 맞춤형 안전 운행 서비스를 제공합니다.
                        </div>
                    </div>
                </div>
                <div className={styles.card}>
                    <div>
                        <img src={IMAGEPATH.b3} srcSet={IMAGEPATH.b3Webp} alt="ar247_tech_image_3" loading="lazy" />
                    </div>
                    <div className={styles.cardContent}>
                        <div>
                            <span>
                                {KR.label_home_motion}
                            </span>
                        </div>
                        <div>
                            <strong>
                                Node 기반 로봇 전역경로 구축
                            </strong>
                            정밀 지도를 바탕으로 출발지부터 도착지까지 전역
                            경로(Global path)를 생성해 효율적인 이동을 보장합니다.
                        </div>
                        <div>
                            <strong>
                                다목적 도착지 설정 및 안전 경로 제공
                            </strong>
                            횡단보도, 어린이보호구역 등 변화하는 환경에 맞춰 실시간 안전한
                            지역경로(Local path) 생성하며, 100개 이상의 목적지를 설정해
                            유동적인 경로를 생성하여 고객의 요구를 충족합니다.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
